<template>
<div class="chapter">
<div class="inner_page">
<p class="pt" id="pt1"><span href="#/xhtml/contents#c_pt1" title="Link target outside of Sample"><span class="epub-b">JANUARY</span></span></p>
<p class="pst"><span href="#/xhtml/contents#c_pt1" title="Link target outside of Sample"><span class="epub-b">Ghost Homes of London</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?0f039ebf